import { jsx as _jsx } from "react/jsx-runtime";
import { EventIcon } from "@faire/retailer-visitor-shared/components/Events/shared/EventIcon";
import { FaireMarketTheme } from "@faire/web--source/slate/Theme/EventsTheme";
import * as React from "react";
export var FaireMarketIcon = function(props) {
    var _FaireMarketTheme_eventIcon;
    return /*#__PURE__*/ _jsx(EventIcon, {
        size: props.size,
        customIcon: (_FaireMarketTheme_eventIcon = FaireMarketTheme.eventIcon) === null || _FaireMarketTheme_eventIcon === void 0 ? void 0 : _FaireMarketTheme_eventIcon.Component,
        className: props.className
    });
};
